import { render, staticRenderFns } from "./OptionGroupProduction.vue?vue&type=template&id=fbe08a84&scoped=true&"
import script from "./OptionGroupProduction.vue?vue&type=script&lang=js&"
export * from "./OptionGroupProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe08a84",
  null
  
)

export default component.exports